import React from 'react';

import { LoveScore } from 'src/explore/elements/LoveScore';
import { StarShipper } from 'src/explore/elements/StarShipper';

import styles from './index.module.sass';

interface AccoladesProps {
  loveScore?: number;
  starShipper: boolean;
}

export const Accolades = ({ loveScore, starShipper }: AccoladesProps ) => (
  <div className={`${styles.container} d-flex`}>
    {loveScore && <LoveScore className={{ tether: styles.item }} score={loveScore} />}

    {starShipper && <StarShipper className={{ tether: styles.item }} />}
  </div>
);
